const Chat = {
  state: {
    isShowChat: false
  },
  mutations: {
    setIsShowChat(state: Record<string, any>, payload: boolean) {
      state.isShowChat = payload;
    }
  },
  getters: {
    isShowChat: (state: Record<string, any>) => state.isShowChat
  }
};

export default Chat;
